import {decodeCookie, encodeCookie} from "@wikicasa/common/common";

export let favourites: Array<Array<number>> = [];

export function init(): void {
    favourites = getFavourites();

    for (let i = 0; i < favourites.length; i++) {
        const id = favourites[i][0];
        $(`#saveRE-${id}, #saveRE-mobile-${id}`).hide();
        $(`#removeRE-${id}, #removeRE-mobile-${id}`).show();
    }

    $(document).on("click", ".fav-save", (e: JQuery.ClickEvent) => {
        const elem = $(e.currentTarget);
        const id = $(elem).data("id");
        //const url = $(elem).data("url");
        add(id);
    });

    $(document).on("click", ".fav-remove", (e: JQuery.ClickEvent) => {
        e.stopImmediatePropagation();
        const elem = $(e.currentTarget);
        const id = elem.data("id");
        remove(id);

        if (elem.data("remove")) {
            elem.closest("li").hide();
        }
    });

}

export function add(id: number, urlDetail?: number): void {

    if (indexOf(id) > -1)
        return;

    favourites.push([id]);

    saveFavourites(favourites);

    $(`.fav-save[data-id="${id}"]`).hide();
    $(`.fav-remove[data-id="${id}"]`).show();

    checkCount();
}

export function remove(id: number): void {

    const index = indexOf(id);

    if (index > -1)
        favourites.splice(index, 1);

    saveFavourites(favourites);

    $(`.fav-save[data-id="${id}"]`).show();
    $(`.fav-remove[data-id="${id}"]`).hide();

    checkCount();
}

export function indexOf(id: number): number {

    let index = -1;

    for (let i = 0; i < favourites.length; i++) {

        if (favourites[i][0] === id) {
            index = i;
            break;
        }
    }

    return index;
}

export function reset(): void {
    saveFavourites([]);
    updateCounter(0);
}

function getFavourites(): Array<Array<any>> {
    const x = decodeCookie("SavedRealEstates");
    if (x != null && x.length > 0)
        favourites = x as Array<Array<any>>;

    return favourites;
}

function saveFavourites(favourites: any): void {
    encodeCookie("SavedRealEstates", favourites);
}

export function checkCount(): void {

    if (favourites.length === 0) {
        $("#favourites-empty").show();
    } else {
        const ids = [];
        for (let i = 0; i < favourites.length; i++)
            ids.push(favourites[i][0]);
    }
    updateCounter(favourites.length);
}

function updateCounter(count: number): void {
    $(".favourite-counter").html(count.toString());
}

function jsonServerCall(config: any): void {
    $.ajax({
        dataType: config.dataType ? config.dataType : "json",
        contentType: config.contentType ? config.contentType : "application/json",
        type: config.type ? config.type : "GET",
        url: config.url,
        data: JSON.stringify(config.data),
        success: config.success
    });
}